import { FormControl, AbstractControl } from '@angular/forms';

// @dynamic
export class EmailValidators {

    private _regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    public static pattern(c: FormControl): any {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if ( regex.test( c.value ) ) {
            return null;
        } else {
            return {
                emailPatternInvalid: true
            };
        }
    }

    public static optional(c: FormControl): any {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regex.test(c.value) || c.value === '') {
            return null;
        } else {
            return {
                emailPatternInvalid: true
            };
        }
    }

    public static unique(emails: string[] = []): any {
        return (c: AbstractControl): {[key: string]: any} | null => {
            if (c == null || c.value == null) {
                return null;
            } else if (emails.findIndex(x => x.toLowerCase() == c.value.toLowerCase()) == -1) {
                return null;
            } else {
                return {notUnique: true};
            }
        };
    }
}
